import { apiCaching } from "../config/cachingConfig";
import { getCachedAPIResponse } from "../apiCaching/apiWrapper";

import { getWeblocationPathGroupWithSiteConfig, setLocalTagLineText } from "./share";

export async function getMessagesData() {
    const urlSiteConfig = await getWeblocationPathGroupWithSiteConfig();
    try{
        if(urlSiteConfig){
            const cachedResponse = await getCachedAPIResponse(urlSiteConfig, apiCaching.SiteConfig, false);
            if (cachedResponse) {
                localStorage.setItem('siteConfigDisplayClickToCallCta' , cachedResponse?.displayClickToCallCta ?? false);
                localStorage.setItem('siteConfigHideOSCTA', cachedResponse?.hideLocalOsCta ?? false);
                setLocalTagLineText(cachedResponse);
                return cachedResponse
            }
        }
        
    }
    catch{
        console.error("Error in fetching site config");
        return {}
    }
}

